import React from "react";
import strings from "../lang/Localiz";
import useStore from "../store";

function Rules() {
  const readInfo = useStore((state) => state.readInfo);
  const setReadInfo = useStore((state) => state.setReadInfo);


  React.useEffect(() => {
    if (readInfo) return
    setReadInfo(true);
    const link = document.querySelector('.link-menu')
    link.classList.add('highlight')
  }, [])

  return (
    <>
      <div className={"rules-block"}>
        <div className={"rules-block-hud"}>
          <div className={"title-block"}>{strings.info}</div>
          <p>{strings.description.txt1}</p>
          <p>{strings.description.txt2}</p>
          <p>{strings.description.txt3}</p>
          <p>{strings.description.txt3_1}</p>
          <h2>{strings.description.lolipops}</h2>
          <p>{strings.description.txt4}</p>
          <p>{strings.description.txt5}</p>
          <ul>
            <li>{strings.description.lolipopsTxt.txt1}</li>
            <li>{strings.description.lolipopsTxt.txt2}</li>
            <li>{strings.description.lolipopsTxt.txt3}</li>
            {strings.description.lolipopsTxt.txt5 && <li>{strings.description.lolipopsTxt.txt5}</li>}
          </ul>
          <h2>{strings.description.contracts.title}</h2>
          <p>{strings.description.contracts.txt1}</p>
          <p>{strings.description.contracts.txt2}</p>
          <p>{strings.description.contracts.txt3}</p>
          <p>{strings.description.contracts.txt4}</p>
          <h2>{strings.description.contracts.bronze.title}</h2>
          <ul>
            <li>{strings.description.contracts.bronze.txt1}</li>
            <li>{strings.description.contracts.bronze.txt2}</li>
            <li>{strings.description.contracts.bronze.txt3}</li>
            <li>{strings.description.contracts.bronze.txt4}</li>
            <li>{strings.description.contracts.bronze.txt5}</li>
            <li>{strings.description.contracts.bronze.txt6}</li>
            <li>{strings.description.contracts.bronze.txt7}</li>
          </ul>
          <h2>{strings.description.contracts.silver.title}</h2>
          <ul>
            <li>{strings.description.contracts.silver.txt1}</li>
            <li>{strings.description.contracts.silver.txt2}</li>
            <li>{strings.description.contracts.silver.txt3}</li>
            <li>{strings.description.contracts.silver.txt4}</li>
            <li>{strings.description.contracts.silver.txt5}</li>
            <li>{strings.description.contracts.silver.txt6}</li>
            <li>{strings.description.contracts.silver.txt7}</li>
          </ul>
          <h2>{strings.description.contracts.gold.title}</h2>
          <ul>
            <li>{strings.description.contracts.gold.txt1}</li>
            <li>{strings.description.contracts.gold.txt2}</li>
            <li>{strings.description.contracts.gold.txt3}</li>
            <li>{strings.description.contracts.gold.txt4}</li>
            <li>{strings.description.contracts.gold.txt5}</li>
            <li>{strings.description.contracts.gold.txt6}</li>
            <li>{strings.description.contracts.gold.txt7}</li>
          </ul>
          <p>{strings.description.contracts.important.title}</p>
          <ul>
            <li>{strings.description.contracts.important.txt1}</li>
            <li>{strings.description.contracts.important.txt2}</li>
            <li>{strings.description.contracts.important.txt3}</li>
            <li>{strings.description.contracts.important.txt4}</li>
          </ul>
          <p>{strings.description.contracts.note}</p>
          <h2>{strings.description.start}</h2>
          <p>{strings.description.txt7}</p>
          <p>{strings.description.txt8}</p>
          <p>{strings.description.txt8_1}</p>
          <h2>{strings.description.islands}</h2>
          <p>{strings.description.txt9}</p>
          <p>{strings.description.txt10}</p>
          <ul>
            <li>{strings.description.txt11}</li>
            <li>{strings.description.txt12}</li>
            <li>{strings.description.txt13}</li>
          </ul>
          <p>{strings.description.txt13_1}</p>
          <h2>{strings.description.checkpoints}</h2>
          <p>{strings.description.txt14}</p>
          <p>{strings.description.txt15}</p>
          <p>{strings.description.txt16}</p>
          <h2>{strings.description.prizes}</h2>
          <h3>{strings.description.checkpointPrizes.point1.title}</h3>
          <ul>
            <li>{strings.description.checkpointPrizes.point1.prize1}</li>
            <li>{strings.description.checkpointPrizes.point1.prize2}</li>
          </ul>
          <h3>{strings.description.checkpointPrizes.point2.title}</h3>
          <ul>
            <li>{strings.description.checkpointPrizes.point2.prize1}</li>
          </ul>
          <h3>{strings.description.checkpointPrizes.point3.title}</h3>
          <ul>
            <li>{strings.description.checkpointPrizes.point3.prize1}</li>
          </ul>
          <h3>{strings.description.checkpointPrizes.point4.title}</h3>
          <ul>
            <li>{strings.description.checkpointPrizes.point4.prize1}</li>
          </ul>
          <h3>{strings.description.checkpointPrizes.point5.title}</h3>
          <ul>
            <li>{strings.description.checkpointPrizes.point5.prize1}</li>
          </ul>
          <h3>{strings.description.checkpointPrizes.point6.title}</h3>
          <ul>
            <li>{strings.description.checkpointPrizes.point6.prize1}</li>
          </ul>
          <h3>{strings.description.checkpointPrizes.point7.title}</h3>
          <ul>
            <li>{strings.description.checkpointPrizes.point7.prize1}</li>
          </ul>
          <h2>{strings.description.missions}</h2>
          <p>{strings.description.txt18}</p>
          {strings.description.missionsArr.map((item, index) => {
            return (
              <>
                <h3>{item.title}</h3>
                <ul>
                  {item.list.map((prize, index) => {
                    return <li>{prize}</li>;
                  })}
                </ul>
              </>
            );
          })}
          <p>{strings.description.txt19}</p>
        </div>
      </div>
    </>
  );
}

export default Rules;
